import { useState } from 'react';
import { assignLead as assignLeadApi } from '../api/assignLead';
import type { Lead } from '../types';

/**
 * Hook for assigning a lead to an estimator
 * Returns mutation function and loading/error states
 */
export function useAssignLead() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const assignLead = async (
    leadId: number,
    assignedToId: number,
    commissionOverride?: number
  ): Promise<Lead> => {
    setIsLoading(true);
    setError(null);

    try {
      // Convert percentage (0-100) to decimal (0-1) if provided
      const commissionDecimal = commissionOverride !== undefined
        ? commissionOverride / 100
        : undefined;

      const updatedLead = await assignLeadApi(leadId, assignedToId, commissionDecimal);
      return updatedLead;
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      const errorMessage = error.response?.data?.message || 'Failed to assign lead';
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    assignLead,
    isLoading,
    error,
  };
}
